import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, EstablishmentsData } from './types';

const initialState: initState = {
  list: {
    data: [],
    meta: {
      totalCount: 0
    },
  },
};

const establishmentsSlice = createSlice({
  name: 'establishments',
  initialState,
  reducers: {
    setEstablishmentsData(state: initState, action: PayloadAction<{ list: EstablishmentsData }>) {
      state.list = action.payload.list;
    },
  },
});

export const { setEstablishmentsData } = establishmentsSlice.actions;

export default establishmentsSlice.reducer;
